<template>
  <div id="step10">
    <div class="main-container flex-column align-center">

      <h2 class="text-center title">指輪のサイズをお選びください。</h2>
      <div class="inner-container">
        <h3 class="option-title">2号から12.5号</h3>
        <div class="select-wrapper">
          <select v-model="selectedSize" class="select">
            <option :value="null" disabled>選択</option>
            <option :value="(item + 3) * 0.5" v-for="(item, idx) in ((25 - 4) + 1)" :key="idx"
                    :item="item"># {{(item + 3) * 0.5}}</option>
          </select>
          <span class="select-icon"></span>
        </div>
      </div>

      <div class="oval flex justify-space-between warning-wrapper">
        <i class="fas fa-info-circle"></i>
        <p class="summary-txt">サイズが不明の方は、「不明」を選択してください。</p>
      </div>

      <div>
        <input type="radio" id="f1" v-model="selectedSize" value="00">
        <label for="f1" class="label label1">不明（12.5号以下）</label>
      </div>

      <div class="inner-container">
        <h3 class="option-title">13号から22号</h3>
        <div class="select-wrapper">
          <select v-model="selectedSize" class="select">
            <option :value="null" disabled>選択</option>
            <option :value="(item + 25) * 0.5" v-for="(item, idx) in ((44 - 26) + 1)" :key="idx"
                    :item="item">#{{(item + 25) * 0.5}}</option>
          </select>
          <span class="select-icon"></span>
        </div>
      </div>

      <div>
        <input type="radio" id="f2" v-model="selectedSize" value="99">
        <label for="f2" class="label label2">不明（13号以上）</label>
      </div>
      
    </div>
  </div>
</template>

<script>
import {computed, ref, watch} from "vue"
import useDialogBuilder from "@/modules/moduleA/helpers/useDialogBuilder";
import {useStore} from "vuex";
export default {
  name: "Step10",
  setup(){
    const {selectItem, removeItem, storeItem, selectedItem} = useDialogBuilder()
    const selectedSize = ref(null)
    const store = useStore()

    const results = computed(() => {
      return store.state.moduleA.results
    })

    watch(() => selectedSize.value, (val) => {
      let valForName = "";
      if(val == "00") {
        valForName = "不明（12.5号以下）"
      }else if(val == "99") {
        valForName = "不明（13号以上）"
      }else{
        valForName = val
      }
      const data = {
        id:10000,
        step: 10,
        stepJp: "指輪のサイズ",
        name: valForName,
        property: "ringSize",
        val: val,
        summary:"",
      }

      storeItem(data)
      selectItem()
    })

    setTimeout(() => {
      const data = results.value.find(item => {
        return item.step === 10
      })
      if (data){selectedSize.value = data.val}
    }, 300)

    return {selectItem, removeItem, selectedSize, selectedItem}
  }

}
</script>
<style>

#step10 > .main-container > h2.title {
  font-weight: 400;
  padding: 50px 0 30px 0;
}

#step10 > .main-container > .warning-wrapper {
  background-color: #f5f6fa;
  width: 350px;
  padding: 10px;
  margin: 20px 0;
  border-radius: 10px;
  font-size: .8rem;
}
#step10 > .main-container > .warning-wrapper > i {
  color: #838383;
  position: relative;
  top: 3px;
  margin-right: 5px;
}

#step10 > .main-container > .inner-container > h3.option-title {
  font-weight: 400;
  font-size: .85rem;
  margin-bottom: 5px;
}
#step10 > .main-container > .inner-container > .select-wrapper {
  height: 40px;
  width: 350px;
  position: relative;
}
#step10 > .main-container > .inner-container > .select-wrapper > select {
  -webkit-appearance: none;
  display: block;
  border-radius: 35px;
  border: 1px solid #dcdde1;
  outline: 0;
  padding-left: 20px;
  font-size: 1rem;
  width: 100%;
  height: 100%;
}
#step10 > .main-container > .inner-container > .select-wrapper > span.select-icon {
   position: absolute;
   display: block;
   width: 22px;
   height: 12px;
   background-size: cover;
   top:52%;
   transform: translateY(-50%);
   right: 20px;
   background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAgCAYAAABHA7voAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAOKADAAQAAAABAAAAIAAAAAB+D5YqAAABf0lEQVRYCdXX0XHCMAwAUAoLdAS6AZ/5ZIRu0IyQETpCNqBsQLfIZ7tBu0FHqJRDuUCNKtuSUHwXnMiOrXeJyXm1mpWu61o4DrPQYk4xb8z/OuENBc6NiNs1TbMdhuGd2qLX54fSQp7PkPs35P5BOY/AGY7ii0HOcJT7BXKTwFHH8MgEjnKfkGuI7CmaqMOuSQZHjA5P1n3ft1Af8eJGCYcU4D7BskfPuAZhUZ5gcT7B9Q6DiRLmdZXi4MH9oGP6F10CMhd3AcSLyMgS3B9gVGQpLgmMhqzB3QRGQdbiWOC9kRq4f4H3QmrhREBvpCZODPRCauOygNZIC1w20ApphSsCaiMtccVALaQ1rgpYi/TAVQNLkV44FWAu0hOHuT3gj1aB5N9grBdmvC9o2zLt406cNqtMP3HTtOEV38F0FOwnH5nb1XE4lyoQBxQgsdt1McHhJOpAHDQTaYYzA2YgTXGmQAHSHGcOZJAuOBdgAumGw7ldC3wnX+HgPhXq+fwCSVJscmPvOgkAAAAASUVORK5CYII=");
   pointer-events: none;
 }

#step10 > .main-container > .select-button {
  margin-top: 40px;
  border-bottom-right-radius: 14px;
  border-bottom-left-radius: 14px;
  height: 70px;
  width: 100%;
}
#step10 > .main-container > .select-button > button {
  position: relative;
  z-index: 2;
  width: 100px;
  height: 40px;
  margin: 0 10px;
  padding-top: 2px;
  letter-spacing: 1.2px;
  background-color: rgba(245, 246, 250, .3);
  border: 2px solid rgba(220, 221, 225,1.0);
  color: #22252f;
}
#step10 > .main-container > .select-button > button:hover {
  transform: translateY(-3px);
  background-color: #171717;
  border-color: white;
  color: white;
}

#step10 input[type=radio] {
display: none; /* ラジオボタンを非表示にする */
}
#step10 .label {
  background: white;
  color: #000;
  border: 2px solid #c8c8c9;
  margin-bottom: 10px;
  padding-left: 20px;
  display: block;
  width: 350px;
  text-align: center;
  padding: 8px 0;
  border-radius: 50px;
}
#step10 input[type="radio"]:checked + label{
  background: #000;
  color: #fff;
}
#step10 .label1 {
  margin-bottom: 40px;
}
#step10 .label2 {
  margin-top: 20px;
}
</style>
